import React from 'react';
import T from 'prop-types';

import Tooltip from '../../../../components/Tooltip';

const WithTooltipIcon = ({ children, tooltipContent, tooltipMaxWidth = 300, gap = 4 }) => (
  <div className={`d-flex align-items-center gap-${gap}`}>
    {children}
    {tooltipContent && (
      <Tooltip
        colorVariant="light"
        content={tooltipContent}
        overlayStyle={{ maxWidth: tooltipMaxWidth }}
        overlayClassName="title-caption-tooltip"
      >
        <i className="hicon-question-circle text-muted text-16" />
      </Tooltip>
    )}
  </div>
);

WithTooltipIcon.propTypes = {
  children: T.node.isRequired,
  tooltipContent: T.node,
  tooltipMaxWidth: T.number,
  gap: T.number,
};

export default WithTooltipIcon;
